const NumberUtils = {
    /**
     * If a number contains decimals, it fixed it up to the decimal places specified.
     * If not, it keeps the number as it is, without any decimal place
     * @param {Number} Number
     * @param {Number} places Decimal places (2 by default)
     * @returns {String}
     */
    withDecimalsIfNeeded: (number, places = 2) => {
        if (Math.round(number) !== number) {
            return Number(number).toFixed(places)
        }

        return Number(number).toString()
    },
}

export default NumberUtils
